module.exports = __webpack_public_path__ + "static/media/nordea_open_logo.1766dfeb.png";